import { useState } from "react";
import { TextField, Button } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_URL from "../../config/api";

import "./ResetPassword.css";

const ResetPassword = () => {
    const [email, setEmail] = useState("");
    const [feedback, setFeedback] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFeedback(null);

        try {
            await axios.post(`${API_URL}/api/User/reset-password/request`, {
                email: email
            });
            setFeedback({
                type: "success",
                message: "Se este e‑mail existir, enviamos as instruções de redefinição."
            });
        } 
        catch (error) {
            console.error(error);
            setFeedback({
                type: "error",
                message: "Ocorreu um erro ao solicitar a redefinição."
            });
        }
    };

    return (
        <div className="reset-container">
            <form className="reset-form" onSubmit={handleSubmit}>
                <h2 className="reset-title">Redefinir Senha</h2>
                <p className="reset-instructions">
                    Insira seu e‑mail cadastrado. Se ele existir, enviaremos as instruções.
                </p>
                <TextField
                    fullWidth
                    label="E‑mail"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    size="small"
                    className="reset-input"
                    required
                />
                <Button
                    variant="contained"
                    type="submit"
                    className="reset-button"
                    fullWidth
                >
                    Enviar
                </Button>

                {feedback && (
                    <p className={`reset-feedback ${feedback.type}`}>{feedback.message}</p>
                )}

                <p
                    className="back-to-login"
                    onClick={() => navigate("/")}
                >
                    Voltar para login
                </p>
            </form>
        </div>
    );
};

export default ResetPassword;
